export default __webpack_public_path__ + "static/media/service2.2d1280fb.svg";